/**
 * /dns-reporting — migrated from public/js/dns-reporting.js.
 *
 * Mai multe handlere:
 *   1. Focus/blur pe .req-form input — clasa .ds-active pe grandparent
 *   2. Submit pe form.req-form — show loader (pagina GET → revine)
 *   3. .layer-table .top-menu click — toggle .active pe tab-uri
 *   4. .domains-menu click pe link cu data-domain — redirect catre /dns?domain=X
 */
import { Resort } from '../core/resort.js';

new Resort((rt) => {
    $('.req-form input', true).on('focus', function (this: Element) {
        const obj = this.parentNode?.parentNode as Element | null;
        if (obj && !obj.classList.contains('ds-active')) obj.classList.add('ds-active');
    });

    $('.req-form input', true).on('blur', function (this: Element) {
        const obj = this.parentNode?.parentNode as Element | null;
        if (obj?.classList.contains('ds-active')) obj.classList.remove('ds-active');
    });

    ($('form.req-form') as Element | null)?.on('submit', () => {
        rt.showModal();
        rt.showLoader();
    });

    window.addEventListener('load', () => {
        rt.hideModal();
        rt.hideLoader();
    });

    const topMenu = $('.layer-table .top-menu') as Element | null;
    if (topMenu) {
        topMenu.on('click', 'a', function (this: Element) {
            topMenu.find('a.active', (item: Element) => { item.classList.remove('active'); return true; });
            this.classList.add('active');
        });
    }

    ($('.domains-menu') as Element | null)?.on('click', 'a', function (this: Element, e: Event) {
        const el = this as unknown as HTMLAnchorElement;
        if (!el.dataset['domain']) return; // fallback la href natural
        e.preventDefault();
        rt.showModal();
        rt.showLoader();
        window.location.href = `/dns?domain=${encodeURIComponent(el.dataset['domain']!)}`;
    });
});
